// components/SuccessMessage.tsx

import React from "react";
import { CheckCircleOutlined } from "@ant-design/icons";

interface SuccessMessageProps {
    message?: string;
    onClose?: () => void;
}

const SuccessMessage: React.FC<SuccessMessageProps> = ({ message }) => {
    return (
        <div className="min-h-screen flex items-center justify-center w-full bg-[#e5e8f3] px-4 py-10">
            <div className="bg-white rounded-lg shadow-lg p-6 sm:p-10 md:p-20 lg:p-32 xl:p-40 w-full max-w-4xl">
                <div className="flex items-center flex-col gap-4 text-center">
                    <CheckCircleOutlined className="text-[80px] sm:text-[100px] md:text-[120px] lg:text-[150px] text-orange-600" />
                    <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-800">
                        Success
                    </h2>
                    <span className="text-base sm:text-lg font-medium text-gray-600">
                        Thank you for submitting the details. We will review your request and get back to you shortly.
                    </span>
                </div>
            </div>
        </div>
    );
};

export default SuccessMessage;
